export const CURRENCY_CODES = [
	"KES",
	"INR",
	"EUR",
	"CFA",
	"USD",
	"RWF",
	"NGN",
	"ZAR",
	"OMR",
	"UGX",
	"PKR",
	"TZS",
	"MUR",
	"ZMW",
	"BWP",
	"MXN",
	"GHS",
	"AED",
	"SAR",
	"POINTS"
];

export const ORDER_STATUS_DELIVERED = 1;
export const CUSTOM_DISCOUNT_CODE = "CUSTOM_DISCOUNT";
export const CURRENCY_DECIMALS = { BHD: 3, JOD: 3, KWD: 3, OMR: 3, TND: 3 };
export const INBOX_MESSAGE_TYPE_STAFF_GPS = 2001;
export const INBOX_MESSAGE_TYPE_ROUTE_PLAN = 2002;

export const TIME_ZONES = {
	"Africa/Nairobi": "Kenya",
	UTC: "GMT",
	"Africa/Johannesburg": "South Africa",
	"Africa/Lagos": "Nigeria",
	"Asia/Muscat": "Oman",
	"Asia/Kolkata": "India",
	"Asia/Karachi": "Pakistan",
	"Europe/Amsterdam": "Netherlands",
};
export const ORG_SETTINGS = {
	WA_REDIRECTION_POPUP: "wa_redirection_popup",
	LAST_PURCHASED_MSG_TAG: "last_purchased_message_tag",
};

export const ORG_FEATURE_FLAGS = {
	LOYALTY_QR: "loyalty_qr",
	DOWNLOAD_ORDER_INVOICE: "download_order_invoice",
	ROUTE_PLAN: "route_plan",
	ROUTE_PLAN_MANUAL_CHECKIN_CHECKOUT: "route_plan_manual_checkin_checkout",
	ROUTE_PLAN_SHOP_PHOTO: "route_plan_shop_photo",
	NON_COMMERCE: "non_commerce",
	SHOW_PAYMENT_LINK_AS_BUTTON: "show_payment_link_as_button",
	GEO_BASED_SHOP_SELECTION: "geo_based_routing_in_wa",
	CONVERSATIONAL_ANALYZER: "conversational_analyzer",
	RETENTION_AGENT: "retention_agent",
};

export const OVERVIEW_PAGE_VISIBLE_MS = 7 * 24 * 60 * 60 * 1000;

export const ERP = {
	SHOPIFY: { label: "Shopify", id: "shopify" },
	WOOCOMMERCE: { label: "Woo Commerce", id: "woocommerce" },
	ERPNEXT: { label: "ERP Next", id: "erpnext" },
	MISCELLANEOUS: { label: "Miscellaneous ERP", id: "miscellaneous_erp" },
	MAGENTO: { label: "Magento", id: "magento" },
	QUICKBOOKS: { label: "Quickbooks", id: "quickbooks" },
	ODOO: {label: "Odoo", id: "odoo"}
};

export const LOGISTICS = {
	SHIPRAZOR: { label: "Shiprazor", id: "shiprazor" },
	UBER_DIRECT: { label: "Uber Direct", id: "uber_direct" }
};

export const BROADCAST_ERROR_CODES = {
	"0": {
		"description": "AuthException - We were unable to authenticate the app user.",
		"possible_solutions": "Get a new access token.",
		"http_status_code": 401
	},
	"3": {
		"description": "API Method - Capability or permissions issue.",
		"possible_solutions": "Use the access token debugger to verify permissions.",
		"http_status_code": 500
	},
	"10": {
		"description": "Permission Denied - Permission is either not granted or has been removed.",
		"possible_solutions": "Use the access token debugger to verify permissions.",
		"http_status_code": 403
	},
	"190": {
		"description": "Access token has expired.",
		"possible_solutions": "Get a new access token.",
		"http_status_code": 401
	},
	"200-299": {
		"description": "API Permission - Permission is either not granted or has been removed.",
		"possible_solutions": "Use the access token debugger to verify permissions.",
		"http_status_code": 403
	},
	"368": {
		"description": "Temporarily blocked for policies violations.",
		"possible_solutions": "See the Policy Enforcement document.",
		"http_status_code": 403
	},
	"130497": {
		"description": "Business account is restricted from messaging users in this country.",
		"possible_solutions": "See WhatsApp Business Messaging Policy.",
		"http_status_code": 403
	},
	"131031": {
		"description": "Account has been locked.",
		"possible_solutions": "See the Policy Enforcement document or use the Health Status API.",
		"http_status_code": 403
	},
	"1": {
		"description": "API Unknown - Invalid request or possible server error.",
		"possible_solutions": "Check the WhatsApp Business Platform Status page.",
		"http_status_code": 400
	},
	"2": {
		"description": "API Service - Temporary due to downtime or due to being overloaded.",
		"possible_solutions": "Check the WhatsApp Business Platform Status page.",
		"http_status_code": 503
	},
	"33": {
		"description": "Parameter value is not valid - The business phone number has been deleted.",
		"possible_solutions": "Verify that the business phone number is correct.",
		"http_status_code": 400
	},
	"100": {
		"description": "Invalid parameter - The request included one or more unsupported or misspelled parameters.",
		"possible_solutions": "See the endpoint's reference for supported parameters.",
		"http_status_code": 400
	},
	"130472": {
		"description": "User's number is part of an experiment - Message was not sent as part of an experiment.",
		"possible_solutions": "See Marketing Message Experiment.",
		"http_status_code": 400
	},
	"131000": {
		"description": "Something went wrong - Message failed to send due to an unknown error.",
		"possible_solutions": "Try again or open a Direct Support ticket.",
		"http_status_code": 500
	},
	"131005": {
		"description": "Access denied - Permission is either not granted or has been removed.",
		"possible_solutions": "Use the access token debugger to verify permissions.",
		"http_status_code": 403
	},
	"131008": {
		"description": "Required parameter is missing - The request is missing a required parameter.",
		"possible_solutions": "See the endpoint's reference for required parameters.",
		"http_status_code": 400
	},
	"131009": {
		"description": "Parameter value is not valid - One or more parameter values are invalid.",
		"possible_solutions": "See the endpoint's reference for supported values.",
		"http_status_code": 400
	},
	"131016": {
		"description": "Service unavailable - A service is temporarily unavailable.",
		"possible_solutions": "Check the WhatsApp Business Platform Status page.",
		"http_status_code": 500
	},
	"131021": {
		"description": "Recipient cannot be sender - Sender and recipient phone number is the same.",
		"possible_solutions": "Send a message to a different phone number.",
		"http_status_code": 400
	},
	"131026": {
		"description": "Message Undeliverable - Unable to deliver message.",
		"possible_solutions": "Confirm recipient's WhatsApp status and version.",
		"http_status_code": 400
	},
	"131037": {
		"description": "WhatsApp provided number needs display name approval before message can be sent.",
		"possible_solutions": "Change the display name.",
		"http_status_code": 400
	},
	"131042": {
		"description": "Business eligibility payment issue - There was an error related to your payment method.",
		"possible_solutions": "Verify billing setup.",
		"http_status_code": 400
	},
	"131045": {
		"description": "Incorrect certificate - Message failed to send due to a phone number registration error.",
		"possible_solutions": "Register the phone number.",
		"http_status_code": 500
	},
	"131047": {
		"description": "Re-engagement message - More than 24 hours have passed since the recipient last replied.",
		"possible_solutions": "Send a business-initiated message using a template.",
		"http_status_code": 400
	},
	"131049": {
		"description": "Meta chose not to deliver - This message was not delivered to maintain healthy ecosystem engagement.",
		"possible_solutions": "Retry in increasing time increments.",
		"http_status_code": 400
	},
	"131050": {
		"description": "User has stopped receipt of marketing messages.",
		"possible_solutions": "Unable to deliver the message. This recipient has chosen to stop receiving marketing messages on WhatsApp from your business.",
		"http_status_code": 400
	},
	"131051": {
		"description": "Unsupported message type - Unsupported message type.",
		"possible_solutions": "See Messages for supported message types.",
		"http_status_code": 400
	},
	"131052": {
		"description": "Media download error - Unable to download the media sent by the user.",
		"possible_solutions": "Ask the user to send media via a non-WhatsApp method.",
		"http_status_code": 400
	},
	"131053": {
		"description": "Media upload error - Unable to upload the media used in the message.",
		"possible_solutions": "Inspect media files for compatibility.",
		"http_status_code": 400
	},
	"131057": {
		"description": "Account in maintenance mode - Business Account is in maintenance mode.",
		"possible_solutions": "Wait until maintenance is complete.",
		"http_status_code": 500
	},
	"132000": {
		"description": "Template Param Count Mismatch - The number of variable parameter values did not match the template.",
		"possible_solutions": "Ensure all variable parameters are included.",
		"http_status_code": 400
	},
	"132001": {
		"description": "Template does not exist - The template does not exist or has not been approved.",
		"possible_solutions": "Ensure the template is approved and correct.",
		"http_status_code": 404
	},
	"132005": {
		"description": "Template Hydrated Text Too Long - Translated text is too long.",
		"possible_solutions": "Check the WhatsApp Manager for template status.",
		"http_status_code": 400
	},
	"132007": {
		"description": "Template Format Character Policy Violated - Template content violates a WhatsApp policy.",
		"possible_solutions": "See Rejection Reasons for details.",
		"http_status_code": 400
	},
	"132012": {
		"description": "Template Parameter Format Mismatch - Variable parameter values formatted incorrectly.",
		"possible_solutions": "See Message Template Guidelines.",
		"http_status_code": 400
	},
	"132015": {
		"description": "Template is Paused - Template is paused due to low quality.",
		"possible_solutions": "Edit the template to improve quality.",
		"http_status_code": 400
	},
	"132016": {
		"description": "Template is Disabled - Template has been permanently disabled.",
		"possible_solutions": "Create a new template.",
		"http_status_code": 400
	},
	"132068": {
		"description": "Flow is blocked - Flow is in blocked state.",
		"possible_solutions": "Correct the Flow.",
		"http_status_code": 400
	},
	"132069": {
		"description": "Flow is throttled - Flow is in throttled state.",
		"possible_solutions": "Correct the Flow.",
		"http_status_code": 400
	},
	"133000": {
		"description": "Incomplete Deregistration - A previous deregistration attempt failed.",
		"possible_solutions": "Deregister the number again.",
		"http_status_code": 500
	},
	"133004": {
		"description": "Server Temporarily Unavailable - Server is temporarily unavailable.",
		"possible_solutions": "Check the WhatsApp Business Platform Status page.",
		"http_status_code": 503
	},
	"133005": {
		"description": "Two step verification PIN Mismatch - Two-step verification PIN incorrect.",
		"possible_solutions": "Verify or reset the two-step verification PIN.",
		"http_status_code": 400
	},
	"133006": {
		"description": "Phone number re-verification needed - Phone number needs to be verified before registering.",
		"possible_solutions": "Verify the phone number.",
		"http_status_code": 400
	},
	"133008": {
		"description": "Too Many two step verification PIN Guesses - Too many PIN guesses for this phone number.",
		"possible_solutions": "Try again after the specified time.",
		"http_status_code": 400
	},
	"133009": {
		"description": "Two step verification PIN Guessed Too Fast - PIN was entered too quickly.",
		"possible_solutions": "Check the details response value.",
		"http_status_code": 400
	},
	"133010": {
		"description": "Phone number Not Registered - Phone number not registered on the WhatsApp Business Platform.",
		"possible_solutions": "Register the phone number.",
		"http_status_code": 400
	},
	"133015": {
		"description": "Please wait a few minutes before attempting to register this phone number - The phone number was recently deleted.",
		"possible_solutions": "Wait 5 minutes before re-trying.",
		"http_status_code": 400
	},
	"135000": {
		"description": "Generic user error - Message failed to send due to an unknown error.",
		"possible_solutions": "Check the endpoint's reference or contact support.",
		"http_status_code": 400
	},
	"2593107": {
		"description": "Synchronization Request limit exceeded - Exceeded the maximum number of synchronization calls.",
		"possible_solutions": "Offboard and re-onboard the business customer.",
		"http_status_code": 400
	},
	"2593108": {
		"description": "Synchronization Request made outside of allowed time window - Synchronization request can only be made within 24 hours of onboarding.",
		"possible_solutions": "Offboard and re-onboard the user.",
		"http_status_code": 400
	},
	"4": {
		"description": "API Too Many Calls - The app has reached its API call rate limit.",
		"possible_solutions": "Reduce API query frequency or try again later.",
		"http_status_code": 400
	},
	"80007": {
		"description": "Rate limit issues - The WhatsApp Business Account has reached its rate limit.",
		"possible_solutions": "Reduce API query frequency or try again later.",
		"http_status_code": 400
	},
	"130429": {
		"description": "Rate limit hit - Cloud API message throughput has been reached.",
		"possible_solutions": "Reduce message frequency or try again later.",
		"http_status_code": 400
	},
	"131048": {
		"description": "Spam rate limit hit - Too many messages were blocked or flagged as spam.",
		"possible_solutions": "Check quality status in the WhatsApp Manager.",
		"http_status_code": 400
	},
	"131056": {
		"description": "(Business Account, Consumer Account) pair rate limit hit - Too many messages sent to the same recipient.",
		"possible_solutions": "Wait and retry the operation.",
		"http_status_code": 400
	},
	"133016": {
		"description": "Account register deregister rate limit exceeded - Too many registration/deregistration attempts.",
		"possible_solutions": "Try again once the number is unblocked.",
		"http_status_code": 400
	}
}


/**
 * The Storefront (nudge engine) pilot gate.
 *
 * Re-exported from the csm source so both admins share one list — csm's own
 * settings tab imports it directly, and this app reaches it through the `csm`
 * alias. Changing who sees the feature is a one-line edit there.
 */
export { STOREFRONT_PILOT_ORG_IDS, canSeeStorefront } from "csm/storefrontAccess";
